import React, { FC, useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { change } from 'redux-form'

import { WizardStepProps } from '~/components/shared/Wizard/types'
import WizardStepWrapper from '~/components/shared/Wizard/WizardStepWrapper'
import Packages from '~/views/Packages/Packages'

import { fetchPackages } from '~/state/modules/package'

const DealerPackageStep: FC<WizardStepProps> = ({ form, onNext }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchPackages('dealer'))
  }, [])

  const handleClick = (p) => {
    dispatch(change(form, 'payment_package_type', p.id))
    onNext()
  }

  return (
    <WizardStepWrapper maxWidth="lg" title="Packages">
      <Packages numberOfSkeletons={1} onClick={handleClick} />
    </WizardStepWrapper>
  )
}

export default DealerPackageStep
